import z from "zod";
import { authedEndpoint } from "../../builder";

export const put = authedEndpoint.mutation(
    (data) => ({
        json: data,
        method: "put",
        url: `remote-storages/${data.id}`,
    }),
    {
        input: z.object({
            id: z.string(),
            name: z.string(),
            config: z.object({
                host: z.string(),
                password: z.string(),
                root: z.string().optional().nullable(),
                username: z.string(),
            }),
        }),
    },
);
